import globals from "./global-variables";

export const LeftArrowWhite = {
  content: "' '",
  background: configuration => `${globals.sprite(configuration)} no-repeat -142px -71px`,
  margin: "auto",
  width: "17px",
  height: "16px",
  position: "absolute",
  top: "50%",
  transform: "translate(0,-50%)",
  display: "inline-block",
  [`@media (${globals.breakpoints.$md})`]: {
    left: "30px",
    right: "auto"
  }
};

export const RightArrowWhite = {
  content: "' '",
  background: configuration => `${globals.sprite(configuration)} no-repeat -173px -72px`,
  margin: "auto",
  width: "17px",
  height: "16px",
  position: "absolute",
  top: "50%",
  transform: "translate(0,-50%)",
  display: "inline-block",
  [`@media (${globals.breakpoints.$md})`]: {
    right: "30px",
    left: "auto"
  }
};

export const LeftArrowGray = {
  content: "' '",
  background: configuration => `${globals.sprite(configuration)} no-repeat -142px -91px`,
  margin: "auto",
  width: "17px",
  height: "16px",
  position: "absolute",
  top: "50%",
  transform: "translate(0,-50%)",
  display: "inline-block",
  [`@media (${globals.breakpoints.$md})`]: {
    left: "30px",
    right: "auto"
  }
};

export const RightArrowGray = {
  content: "' '",
  background: configuration => `${globals.sprite(configuration)} no-repeat -173px -91px`,
  margin: "auto",
  width: "17px",
  height: "16px",
  position: "absolute",
  top: "50%",
  transform: "translate(0,-50%)",
  display: "inline-block",
  [`@media (${globals.breakpoints.$md})`]: {
    right: "30px",
    left: "auto"
  }
};

export const NarrowLongBlackArrow = {
  content: "' '",
  background: configuration => `${globals.sprite(configuration)} no-repeat -52px -18px`,
  margin: "auto",
  width: "17px",
  height: "16px",
  position: "absolute",
  top: "1px",
  transform: "rotate(-90deg)"
};

export const StartOverIcon = {
  content: "' '",
  background: configuration => `${globals.sprite(configuration)} no-repeat -140px -45px`,
  margin: "auto",
  width: "20px",
  height: "19px",
  position: "absolute",
  right: 0,
  left: "auto",
  top: "50%",
  transform: "translate(0,-50%)",
  display: "inline-block"
};

export const DropdownArrow = {
  content: "' '",
  background: configuration => `${globals.sprite(configuration)} no-repeat -86px -94px`,
  margin: "auto",
  height: "16px",
  width: "28px",
  position: "absolute",
  right: "20px",
  display: "inline-block",
  transition: ".3s"
};
